const textFieldFormEquipModel = {
  name: 'Tipo de Equipamento',
  description: 'Descrição do Tipo de Equipamento',
  labelDepreciation: 'Depreciação Anual',
  labelPercentualDepreciation: 'valor entre 0 e 100',
};

export default textFieldFormEquipModel;
